/**
 * Strips html tags from a string and replaces html entities
 * with their unicode equivalents.
 * @param {string} htmlString Html input string
 * @returns {string} Text with html stripped and html entities replaced
 */
export default function stripHtml(htmlString) {
  const htmlStringWithLinebreaks = htmlString.replace(/<br\s*\/?>/g, '\n');

  return new window.DOMParser()
    .parseFromString(htmlStringWithLinebreaks, 'text/html')
    .querySelector('body')
    .textContent;
}
